import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  useTheme
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import TimerIcon from '@mui/icons-material/Timer';
import { useNavigate } from 'react-router-dom';

const ComingSoonDialog = ({ open, onClose }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();

  const handleClose = () => {
    onClose();
    navigate('/');
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ textAlign: 'center', pt: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
          <TimerIcon sx={{ fontSize: 40, color: theme.palette.primary.main, mr: 1 }} />
        </Box>
        {t('comingSoon.title', 'Çok Yakında!')}
      </DialogTitle>
      <DialogContent>
        <Typography align="center" paragraph>
          {t('comingSoon.message', 'Bu özellik çok yakında hizmetinizde olacak. Şu anda geliştirme aşamasındayız.')}
        </Typography>
        <Typography align="center" variant="body2" color="text.secondary">
          {t('comingSoon.subscribe', 'Gelişmelerden haberdar olmak için bizi takip edin.')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button onClick={handleClose} variant="contained">
          {t('common.understand', 'Anladım')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ComingSoonDialog; 